import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { MapPinIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/content';
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduce = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    const show = window.setTimeout(() => setVisible(true), 4000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setIndex(i => (i + 1) % recentPurchases.length);
        setVisible(true);
      }, 600);
    }, 9000);
    return () => {
      window.clearTimeout(show);
      window.clearInterval(cycle);
    };
  }, [dismissed]);
  const p = recentPurchases[index];
  return <div className="pointer-events-none fixed bottom-3 left-3 z-50 max-w-[calc(100vw-1.5rem)] sm:bottom-4 sm:left-4" aria-live="polite" data-id="element-133" data-mp="b4d8qfuod53j">
      <AnimatePresence data-id="element-134" data-mp="1u5zjd3935bgw">
        {visible && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: reduce ? 0 : 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: reduce ? 0 : 8
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex items-center gap-3 rounded-2xl border-2 border-ink bg-cream py-3 pl-3 pr-9 shadow-[4px_4px_0_0_#141210]" data-id="element-135" data-mp="1z5cai06zp4pa">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-kraft" data-id="element-136" data-mp="1ff8x0aq9j4l6">
              <MapPinIcon className="h-5 w-5" aria-hidden="true" data-id="element-137" data-mp="1p7elhahb33vm" />
            </span>
            <div className="text-sm leading-tight" data-id="element-138" data-mp="1p9976r0ej00r">
              <p className="font-display font-extrabold" data-id="element-139" data-mp="rqzf3jw670zb">
                {p.name} de {p.place}
              </p>
              <p className="text-ink-soft" data-id="element-140" data-mp="wpj0nj6uqar5">Acaba de comprar el diario</p>
              <p className="mt-0.5 text-xs text-kraft-dark" data-id="element-141" data-mp="2017vtvwwglxc">{p.ago}</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-2 top-2 rounded-full p-1 text-ink-soft hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-rust" data-id="element-142" data-mp="1v3g698jq9bwb">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-143" data-mp="24tj87y8tu06s" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}